var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"elavation-1 transparent"},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":"","height":"37"}},[_c('v-spacer')],1)],1),_c('app-pages',{attrs:{"app_id":_vm.pageIds.my_attendance}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }